/** Mã lỗi API voucher validate (HTTP 200, `errorCode` != 0). */
export const VOUCHER_API_ERROR_CODES = {
  NOT_FOUND: 30001,
  CODE_DISABLED: 30002,
  NOT_ACTIVE: 30003,
  EXPIRED: 30004,
  LIMIT_REACHED: 30005,
  BALANCE_DEPLETED: 30006,
  INVALID_PRODUCT: 30007,
  CAMPAIGN_DISABLED: 30008,
  MIN_ORDER_VALUE_NOT_MET: 30009,
  INVALID_MARKET: 30010,
  INVALID_CHANNEL: 30011,
  INVALID_PAYMENT_METHOD: 30012,
  INVALID_PAYMENT_GATEWAY: 30013,
  ORDER_VALUE_REQUIRED: 30014,
} as const

export type VoucherApiErrorCode =
  (typeof VOUCHER_API_ERROR_CODES)[keyof typeof VOUCHER_API_ERROR_CODES]

export const VOUCHER_API_ERROR_KEYS: Record<VoucherApiErrorCode, string> = {
  [VOUCHER_API_ERROR_CODES.NOT_FOUND]: "VOUCHER_NOT_FOUND",
  [VOUCHER_API_ERROR_CODES.CODE_DISABLED]: "VOUCHER_CODE_DISABLED",
  [VOUCHER_API_ERROR_CODES.NOT_ACTIVE]: "VOUCHER_NOT_ACTIVE",
  [VOUCHER_API_ERROR_CODES.EXPIRED]: "VOUCHER_EXPIRED",
  [VOUCHER_API_ERROR_CODES.LIMIT_REACHED]: "VOUCHER_LIMIT_REACHED",
  [VOUCHER_API_ERROR_CODES.BALANCE_DEPLETED]: "VOUCHER_BALANCE_DEPLETED",
  [VOUCHER_API_ERROR_CODES.INVALID_PRODUCT]: "VOUCHER_INVALID_PRODUCT",
  [VOUCHER_API_ERROR_CODES.CAMPAIGN_DISABLED]: "VOUCHER_CAMPAIGN_DISABLED",
  [VOUCHER_API_ERROR_CODES.MIN_ORDER_VALUE_NOT_MET]: "VOUCHER_MIN_ORDER_VALUE_NOT_MET",
  [VOUCHER_API_ERROR_CODES.INVALID_MARKET]: "VOUCHER_INVALID_MARKET",
  [VOUCHER_API_ERROR_CODES.INVALID_CHANNEL]: "VOUCHER_INVALID_CHANNEL",
  [VOUCHER_API_ERROR_CODES.INVALID_PAYMENT_METHOD]: "VOUCHER_INVALID_PAYMENT_METHOD",
  [VOUCHER_API_ERROR_CODES.INVALID_PAYMENT_GATEWAY]: "VOUCHER_INVALID_PAYMENT_GATEWAY",
  [VOUCHER_API_ERROR_CODES.ORDER_VALUE_REQUIRED]: "VOUCHER_ORDER_VALUE_REQUIRED",
}

/** Message mặc định (VI) — i18n key: `voucher.errors.<code>`. */
export const VOUCHER_API_ERROR_MESSAGES_VI: Record<VoucherApiErrorCode, string> = {
  [VOUCHER_API_ERROR_CODES.NOT_FOUND]:
    "Mã khuyến mãi không tồn tại, vui lòng đổi mã khác.",
  [VOUCHER_API_ERROR_CODES.CODE_DISABLED]:
    "Mã khuyến mãi đang bị vô hiệu hóa.",
  [VOUCHER_API_ERROR_CODES.NOT_ACTIVE]:
    "Mã khuyến mãi chưa đến thời gian áp dụng.",
  [VOUCHER_API_ERROR_CODES.EXPIRED]:
    "Mã khuyến mãi đã hết hạn sử dụng.",
  [VOUCHER_API_ERROR_CODES.LIMIT_REACHED]:
    "Mã khuyến mãi đã đạt giới hạn số lần sử dụng.",
  [VOUCHER_API_ERROR_CODES.BALANCE_DEPLETED]:
    "Mã khuyến mãi đã hết số dư (ngân sách).",
  [VOUCHER_API_ERROR_CODES.INVALID_PRODUCT]:
    "Mã khuyến mãi không áp dụng cho loại sản phẩm này.",
  [VOUCHER_API_ERROR_CODES.CAMPAIGN_DISABLED]:
    "Chiến dịch khuyến mãi đang bị vô hiệu hóa.",
  [VOUCHER_API_ERROR_CODES.MIN_ORDER_VALUE_NOT_MET]:
    "Giá trị đơn hàng chưa đạt mức tối thiểu để áp dụng mã.",
  [VOUCHER_API_ERROR_CODES.INVALID_MARKET]:
    "Mã khuyến mãi không áp dụng cho thị trường này (Nội địa/Quốc tế).",
  [VOUCHER_API_ERROR_CODES.INVALID_CHANNEL]:
    "Mã khuyến mãi không áp dụng cho kênh bán hàng này.",
  [VOUCHER_API_ERROR_CODES.INVALID_PAYMENT_METHOD]:
    "Mã khuyến mãi không áp dụng cho phương thức thanh toán này.",
  [VOUCHER_API_ERROR_CODES.INVALID_PAYMENT_GATEWAY]:
    "Mã khuyến mãi không áp dụng cho cổng thanh toán này.",
  [VOUCHER_API_ERROR_CODES.ORDER_VALUE_REQUIRED]:
    "Thiếu giá trị đơn hàng để tính giảm giá theo phần trăm.",
}

export const VOUCHER_API_ERROR_CODE_MIN = 30001
export const VOUCHER_API_ERROR_CODE_MAX = 30014

export const isVoucherApiErrorCode = (
  code: number | undefined | null,
): code is VoucherApiErrorCode =>
  typeof code === "number" &&
  code >= VOUCHER_API_ERROR_CODE_MIN &&
  code <= VOUCHER_API_ERROR_CODE_MAX
